import api from "./api";

function unwrap(response) {
  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchFlashCardProgress(params = {}) {
  return unwrap(await api.get("/flash-cards/progress", { params }));
}

export async function fetchFlashCards(params = {}) {
  return unwrap(await api.get("/flash-cards/list", { params }));
}

export async function markFlashCardRead(payload) {
  return unwrap(await api.post("/flash-cards/mark-read", payload));
}

export async function storeFlashCardView(payload) {
  return unwrap(await api.post("/flash-cards/store-view", payload));
}

export async function toggleFlashCardBookmark(payload) {
  return unwrap(await api.post("/flash-cards/bookmark", payload));
}

export async function resetFlashCardProgress(payload) {
  return unwrap(await api.post("/flash-cards/reset-progress", payload));
}

export async function rewardFlashCardAd(payload) {
  return unwrap(await api.post("/flash-cards/ad-reward", payload));
}
